import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCountry20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconCountry20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10 17.5c.784 0 1.54-.12 2.25-.343v-1.532H11a2.5 2.5 0 0 1-2.5-2.5V9.559l.386-.215L15.25 5.81V4.75a1 1 0 0 1 .007-.1 7.5 7.5 0 0 0-2.632-1.678v2.992l-.414.207-1.5.75-.393.196-.363-.246L7.25 5.04v2.768a2.5 2.5 0 0 1-2.5 2.5H2.506A7.5 7.5 0 0 0 10 17.5M2.594 8.807H4.75a1 1 0 0 0 1-1V3.819a7.5 7.5 0 0 0-3.156 4.988M7.06 3.098l3.372 2.285.693-.346V2.584a7.56 7.56 0 0 0-4.065.514m6.69 11.777v1.622A7.5 7.5 0 0 0 17.5 10a7.5 7.5 0 0 0-.764-3.301l-.372.207L10 10.44v2.684a1 1 0 0 0 1 1h2.75zM10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCountry20);
